import { EarningMechanismStoredValueDiscountInput } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { earningMechanismInputCreator } from '@occc-app/offerHelpers/earningMechanismInputCreator';

import { StoredValueConfigureFormValues } from './stored-value-configure-form.types';

export const getStoredValueEarningMechanismOperations = (
  offerId: string,
  values: StoredValueConfigureFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];

  if (
    values.earningMechanism.id &&
    !isFieldDirty<StoredValueConfigureFormValues>(dirtyFields, 'storedValueDiscount')
  ) {
    return operations;
  }

  if (values.earningMechanism.id) {
    operations.push(makeDeleteOperation('earningMechanismDelete', values.earningMechanism.id));
  }

  const storedValueInput: EarningMechanismStoredValueDiscountInput = {
    excludedProductGroupIds: values.storedValueDiscount.excludedProductGroups?.length
      ? values.storedValueDiscount.excludedProductGroups.map((v) => v.id)
      : undefined,
  };

  const configuration = earningMechanismInputCreator.createStoredValueDiscount(storedValueInput);

  operations.push(makeEarningMechanismCreateOperation(offerId, configuration));

  return operations;
};
